import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

const modalRoot = document.querySelector('body') as HTMLElement

interface IProps {
	children?: React.ReactNode
}

const Portal = ({ children }: IProps) => {
	const el = useRef(document.createElement('div'))

	useEffect(() => {
		const current = el.current

		modalRoot!.appendChild(current)
		return () => void modalRoot!.removeChild(current)
	}, [])

	return createPortal(children, el.current)
}

export default Portal
